import {
  computed,
  useNuxtApp,
  useState,
  inject
} from "#imports";
import { getPluralTexts, getSingleText } from "../helpers/textsFunctions.js";
export function useEasyTexts() {
  const override = inject(
    "nuxt_easy_texts_override",
    null
  );
  const isDebugState = useState(
    "nuxt_easy_texts_debug_enabled",
    () => false
  );
  const isDebug = computed(() => isDebugState.value);
  const app = useNuxtApp();
  const textsFunction = override ? function(key, replacements) {
    return getSingleText(key, isDebug.value, override.value, replacements);
  } : app.$texts;
  const textsPluralFunction = override ? function(key, count, replacements) {
    return getPluralTexts(
      key,
      count,
      isDebug.value,
      override.value,
      replacements
    );
  } : app.$textsPlural;
  function enableDebug() {
    isDebugState.value = true;
  }
  function disableDebug() {
    isDebugState.value = false;
  }
  function toggleDebug() {
    isDebugState.value = !isDebugState.value;
  }
  return {
    $texts: textsFunction,
    $textsPlural: textsPluralFunction,
    isDebug,
    enableDebug,
    disableDebug,
    toggleDebug
  };
}
